<template>
  <div>
    <div>
      <!-- Register v1 -->
      <b-card class="mb-0" title="">
        <!-- form -->
        <validation-observer ref="updateUser" #default="{ invalid }">
          <b-form @submit.prevent>
            <!-- Batch -->
            <b-col md="6" cols="12">
              <b-form-group label="Batch" label-for="Batch">
                <validation-provider
                  #default="{ errors }"
                  name="Batch"
                  vid="Batch"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.batch"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Your Batch"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Intake -->
            <b-col md="6" cols="12">
              <b-form-group label="Intake" label-for="Intake">
                <validation-provider
                  #default="{ errors }"
                  name="Intake"
                  vid="Intake"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.intake"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Releted Intake"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- BIT Student -->
            <b-col md="6" cols="12">
              <b-form-group label="Internship" label-for="Internship">
                <validation-provider
                  #default="{ errors }"
                  name="Internship"
                  vid="Internship"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.internship"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Internship Yes / No"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- name -->
            <b-col cols="12">
              <b-form-group label="User Name" label-for="Name">
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  vid="Name"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.name"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Gender"
                label-for="edit-gender"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Gender"
                  vid="gender"
                >
                  <b-form-select
                    id="edit-gender"
                    v-model="form.gender"
                    :options="genderOptions"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- email -->
            <b-col cols="12">
              <b-form-group label="User Email" label-for="Email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="Email"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.email"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- phone -->
            <b-col cols="12">
              <b-form-group label="User Phone" label-for="Phone">
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  vid="phone"
                  rules="required"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.phone"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Phone No"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Use supported payment types so saved values match backend payment rules. -->
            <b-col cols="12">
              <b-form-group label="User Payment Type" label-for="payment-type">
                <validation-provider
                  #default="{ errors }"
                  name="Payment Type"
                  vid="Payment Type"
                >
                  <b-form-select
                    id="payment-type"
                    v-model="form.payment_type"
                    :options="paymentTypes"
                    :state="errors.length > 0 ? false : null"
                    @change="onPaymentTypeChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col v-if="form.payment_type === 'Instalment Payment'" cols="12">
              <b-form-group label="Installment Plan" label-for="installment-plan">
                <validation-provider
                  #default="{ errors }"
                  name="Installment Plan"
                  vid="installment_plan"
                  rules="required"
                >
                  <b-form-select
                    id="installment-plan"
                    v-model="form.installment_plan"
                    :options="installmentPlans"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Due Date -->
            <b-col cols="12">
              <b-form-group label="Due Date" label-for="due-date">
                <validation-provider
                  #default="{ errors }"
                  name="Due Date"
                  vid="due_date"
                >
                  <b-form-input
                    id="due-date"
                    v-model="form.due_date"
                    type="date"
                    name="due_date"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Select Due Date"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- payment value-->
            <b-col cols="12">
              <b-form-group
                label="User Payment Value"
                label-for="Payment Value"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Payment Value"
                  vid="Payment Value"
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.payment_value"
                    name="register-meetingid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Payment Value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
              @click="updateUser()"
            >
              Update
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Register v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import userApi from "@/Api/Modules/auth";
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BButton,
  BFormInput,
  BFormSelect,
  BFormGroup,
  BInputGroup,
  BImg,
  BInputGroupAppend,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

export default {
  name: "Register",
  components: {
    vSelect,
    BCard,

    BCardTitle,
    BImg,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormSelect,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,

    // validations
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    userdata: Object,
  },
  data() {
    return {
      form: {},
      genderOptions: [
        { text: 'Select Gender', value: null },
        { text: 'Male', value: 'Male' },
        { text: 'Female', value: 'Female' },
      ],
      // Values must match the payment_type strings checked by the backend.
      paymentTypes: [
        { text: 'One Time Payment', value: 'One Time Payment' },
        { text: 'Instalment Payment', value: 'Instalment Payment' },
      ],
      installmentPlans: [
        { text: '4 Months', value: 4 },
        { text: '6 Months', value: 6 },
      ],

      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    };
  },

  created() {
    this.initiateData();
  },

  methods: {
    onPaymentTypeChange(paymentType) {
      if (paymentType === 'One Time Payment') {
        this.form.installment_plan = null
      } else if (paymentType === 'Instalment Payment' && !this.form.installment_plan) {
        this.form.installment_plan = 4
      }
    },

    // initiate data

    initiateData() {
      const plan = this.userdata.installment_plan
      let installmentPlan = null
      if (this.userdata.payment_type === 'Instalment Payment') {
        installmentPlan = plan == null || plan === '' ? 4 : Number(plan)
      }
      this.form = {
        ...this.userdata,
        gender: this.userdata.gender ?? null,
        installment_plan: installmentPlan,
      }
    },
    // update

    async updateUser() {
      if (await this.$refs.updateUser.validate()) {
        await this.$vs.loading({
          scale: 0.8,
        });

        await userApi
          .editUser(this.form)
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
  },
};
</script>
